module.exports = __webpack_public_path__ + "img/dsci0085.8bd57830.jpg";